<template>
  <div class="p-4 nutritional-journal">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-1"
    >
      <h5 class="mb-0">Nutritional Journal</h5>
      <div>
        <b-button
          class="pl-3 pr-3 pt-1 pb-1 mr-2"
          variant="primary"
          size="sm"
          @click="$refs['view-modal'].show()"
          ><i class="fa fa-chart-area mr-2"></i>Goal vs Met</b-button
        >
      </div>
    </div>
    <div class="mt-1 mb-0 w-100 d-flex flex-row justify-content-between">
      <div class="d-flex align-items-center" style="font-size: 19px;">
        <div>
          <a
            class="hover-pointer"
            style="font-size: 14px"
            @click="showReportRequestsModal = true"
          >
            <i class="fa fa-download"></i>
            <span class="ml-2 text-primary" style="font-size: 14px"
              >Export</span
            >
          </a>
        </div>
      </div>
    </div>
    <grid
      v-if="client && eoc && eoc.startDate"
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
      :excelExporterFeature="excelExporterFeature"
      @paint="listeners.paint"
      @finishcelledit="listeners.cellEdited"
    ></grid>
    <div
      v-if="eoc && !eoc.startDate"
      class="d-flex justify-content-center align-items-center no-start-date"
    >
      <h6 class="color-custom-dark-grey">
        Please select Start Date to begin.
      </h6>
    </div>
    <b-modal
      centered
      scrollable
      ref="form-modal"
      title="Meal Details"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitMealDeatils"
      size="lg"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <div
          class="d-flex flex-row justify-content-between align-items-center w-100"
        >
          <div>
            <b-button
              variant="danger"
              @click="deleteJournal()"
              v-if="form.mealRecordId"
            >
              Remove meal detail
            </b-button>
          </div>

          <div>
            <b-button class="mr-2" variant="secondary" @click="cancel()">
              Cancel
            </b-button>
            <b-button variant="primary" @click="ok()">
              Save
            </b-button>
          </div>
        </div>
      </template>
      <div class="nutrition-journal-modal-body">
        <b-row>
          <b-col cols="8">
            <div>
              <div class="d-flex align-items-center w-100">
                <b-form-group label="Qty">
                  <b-form-input v-model="form.foodQty" trim></b-form-input>
                </b-form-group>
                <b-form-group label="Food Item" class="w-100 ml-2">
                  <v-select
                    v-model="form.foodItem"
                    :options="foodOptions"
                  ></v-select>
                </b-form-group>
                <b-button
                  class="ml-2 add-item"
                  variant="primary"
                  size="sm"
                  @click="addFoodItem"
                >
                  +
                </b-button>
              </div>
              <grid
                :groupFeature="false"
                :columns="formColumns"
                :autoHeight="true"
                :data="selectedFoodItems"
                :columnLines="false"
                :searchFeature="true"
                :stripeFeature="true"
              />
              <span class="float-right mt-2">
                Total: {{ foodItemsTotalCalories }} Calories
              </span>
            </div>
            <div>
              <div class="d-flex align-items-center w-100 mt-3">
                <b-form-group label="Qty">
                  <b-form-input
                    v-model="form.supplementQty"
                    trim
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Supplement" class="w-100 ml-2">
                  <v-select
                    v-model="form.supplement"
                    :options="supplementOptions"
                  ></v-select>
                </b-form-group>
                <b-button
                  class="ml-2 add-item"
                  variant="primary"
                  size="sm"
                  @click="addSupplement"
                >
                  +
                </b-button>
              </div>
              <grid
                :groupFeature="false"
                :columns="formColumns"
                :autoHeight="true"
                :data="selectedSupplements"
                :columnLines="false"
                :searchFeature="true"
                :stripeFeature="true"
              />
              <span class="float-right mt-2">
                Total: {{ supplementsTotalCalories }} Calories
              </span>
            </div>
            <span
              v-if="formErrors.items.length > 0"
              class="invalid-feedback d-block"
              >{{ formErrors.items.join(", ") }}</span
            >
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <b-form-group
                  label="Percentage of meal consumed*"
                  :state="formErrors.mealPercent.length == 0 ? null : false"
                  :invalid-feedback="formErrors.mealPercent.join(', ')"
                >
                  <b-form-input
                    placeholder=""
                    v-model="form.mealPercent"
                    :state="formErrors.mealPercent.length == 0 ? null : false"
                    type="number"
                    trim
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Water Intake (oz)">
                  <b-form-input
                    placeholder=""
                    v-model="form.fluidIntake"
                    trim
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <p>Calories Consumed:</p>
                <p>
                  {{ percentTotalItemsValue }}
                  calories
                </p>
                <p v-if="form.goal && form.goal > 0">
                  {{ percentFromGoal }}% of daily goal of {{ form.goal }}
                </p>
              </b-col>
            </b-row>

            <b-form-group
              label="Comments"
              :state="formErrors.comments.length == 0 ? null : false"
              :invalid-feedback="formErrors.comments.join(', ')"
            >
              <b-form-textarea
                placeholder=""
                v-model="form.comments"
                rows="11"
                max-rows="11"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      centered
      ref="view-modal"
      title="Goal vs Met"
      header-bg-variant="primary"
      header-text-variant="white"
      size="lg"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer=""
        ><b-button
          class="ml-2"
          variant="primary"
          @click="$refs['view-modal'].hide()"
          >Ok</b-button
        >
      </template>
      <div class="modal-chart-container">
        <chart
          :data="viewChartData"
          :options="lineChartOptions"
          :style="lineChartStyles"
          type="line"
        />
      </div>
    </b-modal>
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="NutritionalJournal"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import zipcelx from "zipcelx";
import Grid from "../../third_party/grid/Grid.vue";
import Chart from "../controls/Chart.vue";
import eocServer from "../../server/eoc";
import patientServer from "../../server/patient";
import nutritionalJournalRecordServer from "../../server/nutritionalJournalRecord";
import nutritionJournalMealServer from "../../server/nutritionalJournalMeal";
import { formatDateOnly, enumerateDaysBetweenDates } from "../../helpers/date";
import { on } from "../../helpers/layout";
import { validateRequired } from "../../helpers/validation";
import { randomId } from "../../helpers/general";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";

export default {
  name: "EocViewNutritionalJournal",
  components: {
    Grid,
    Chart,
    ReportRequestIndex
  },
  props: ["eocId", "clientId", "showing"],
  data() {
    const self = this;
    return {
      list: [],
      form: {
        date: "",
        goal: 0,
        mealId: "",
        mealRecordId: "",
        mealPercent: "",
        fluidIntake: "",
        comments: "",
        items: [],
        foodQty: 0,
        foodItem: null,
        supplementQty: 0,
        supplement: null
      },
      formErrors: {
        mealPercent: [],
        items: [],
        comments: []
      },
      listeners: {
        paint: paintEvent => {
          if (paintEvent.firstPaint) {
            window.bryntum.grid.EventHelper.on({
              element: paintEvent.source._element,
              delegate: "img.edit-nutrition-meal-item",
              click: async event => {
                event.stopPropagation();
                const mealId = event.srcElement.dataset.mealId;
                const date = event.srcElement.dataset.date;
                const goal = event.srcElement.dataset.goal;
                this.form.date = date;
                this.form.mealId = mealId;
                this.form.mealRecordId = "";
                this.form.mealPercent = "100";
                this.form.fluidIntake = "";
                this.form.comments = "";
                this.form.items = [];
                this.form.foodQty = 1;
                this.form.foodItem = null;
                this.form.supplementQty = 1;
                this.form.supplement = null;
                this.form.goal = goal;
                const mealRecordId = event.srcElement.dataset.mealRecordId;
                if (mealRecordId) {
                  const recordMeal = await nutritionJournalMealServer.get(
                    mealRecordId
                  );
                  this.form.comments = recordMeal.comments;
                  this.form.mealPercent = recordMeal.percentCosumed;
                  this.form.fluidIntake = recordMeal.fluidIntake;
                  this.form.mealRecordId = mealRecordId;
                  for (
                    let index = 0;
                    index < recordMeal.items.length;
                    index++
                  ) {
                    const item = recordMeal.items[index];
                    this.form.items.push({
                      _id: randomId(),
                      qty: item.quantity,
                      foodItem: item.foodItem
                    });
                  }
                }
                this.$refs["form-modal"].show();
              },
              capture: true,
              thisObj: this
            });
            if (!self.subscribed) {
              self.subscribed = true;
              on(self.$el, "change", ".edit-goal-item", async target => {
                if (target.value < 0) {
                  this.showError({
                    message: "Goal must be greater than or queal to 0"
                  });
                  return;
                }

                let noErrors = true;

                await nutritionalJournalRecordServer
                  .create({
                    date: target.dataset.date,
                    goal: parseFloat(target.value),
                    episodeOfCareId: self.eocId
                  })
                  .catch(e => {
                    noErrors = false;

                    if (e.response.data.errorCode == "goalCannotBeNegative") {
                      this.showError({
                        message: "Goal cannot be negative"
                      });
                    } else this.showError();
                  });
                await self.getNutritionJournals();
                self.calculateChartData();
                if (noErrors) self.showAlertSuccess();
              });
            }
          }
        },
        cellEdited: async event => {
          const record = event.editorContext.record.data;
          await nutritionalJournalRecordServer
            .create({
              date: moment(record.date).format("YYYY-MM-DD"),
              goal: record.goal,
              episodeOfCareId: self.eocId
            })
            .catch(e => {
              if (e.response.data.errorCode == "goalCannotBeNegative") {
                this.showError({
                  message: "Goal cannot be negative"
                });
              }
            });
          await self.getNutritionJournals();
          await self.calculateChartData();
        }
      },
      subscribed: false,
      client: null,
      eoc: null,
      lineChartStyles: {
        height: "100%"
      },
      lineChartOptions: {
        cubicInterpolationMode: "monotone",
        height: 100,
        maintainAspectRatio: false
      },
      viewChartData: null,
      showReportRequestsModal: false
    };
  },
  async mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    ...mapActions("client", [
      "fetchNutritionalJournalItems",
      "fetchNutritionMeals"
    ]),
    async fetchData() {
      await this.getEoc();
      await this.getClient();
      await this.getNutritionJournals();
      await this.fetchNutritionalJournalItems();
      await this.fetchNutritionMeals();
      this.calculateChartData();
    },
    async getEoc() {
      this.eoc = await eocServer.get(this.eocId);
    },
    async getClient() {
      this.client = await patientServer.get(this.clientId);
    },
    async getNutritionJournals() {
      this.list = await nutritionalJournalRecordServer.query(this.eocId);
    },
    calculateChartData() {
      const chartLabels = this.items.map(value => formatDateOnly(value.date));
      const chartGoalData = this.items.map(value => parseFloat(value.goal));
      const chartMetData = this.items.map(value => parseFloat(value.met));
      this.viewChartData = {
        labels: chartLabels,
        datasets: [
          {
            label: "Met",
            borderColor: "#4044E6",
            backgroundColor: "rgba(0, 132, 255, 0.3)",
            data: chartMetData,
            cubicInterpolationMode: "monotone"
          },
          {
            label: "Goal",
            borderColor: "#66C854",
            backgroundColor: "rgba(146, 200, 84, 0.3)",
            data: chartGoalData,
            cubicInterpolationMode: "monotone"
          }
        ]
      };
    },
    validateMealDetailsSubmit() {
      let withoutErrors = true;

      this.formErrors.mealPercent = [];
      if (!validateRequired(this.form.mealPercent)) {
        this.formErrors.mealPercent.push("This field is required");
        withoutErrors = false;
      } else if (
        parseInt(this.form.mealPercent) < 0 ||
        parseInt(this.form.mealPercent) > 100
      ) {
        this.formErrors.mealPercent.push(
          "This field must be between 0 and 100"
        );
        withoutErrors = false;
      }

      this.formErrors.items = [];
      if (this.form.items.length == 0) {
        this.formErrors.items.push("Must add at least one item");
        withoutErrors = false;
      }

      this.formErrors.comments = [];
      if (this.form.comments.length > 2000) {
        this.formErrors.comments.push(
          "The length must be 2000 characters or fewer."
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitMealDeatils(modalEvent) {
      modalEvent.preventDefault();
      const result = await this.validateMealDetailsSubmit();
      if (result) {
        const formData = {
          episodeOfCareId: this.eocId,
          date: this.form.date,
          percentCosumed: parseFloat(this.form.mealPercent),
          fluidIntake: this.form.fluidIntake.toString(),
          comments: this.form.comments,
          nutritionMealId: this.form.mealId,
          items: this.form.items.map(item => ({
            foodItemId: item.foodItem.id,
            quantity: parseFloat(item.qty)
          }))
        };
        if (this.form.mealRecordId)
          await nutritionJournalMealServer.update(
            this.form.mealRecordId,
            formData
          );
        else await nutritionJournalMealServer.create(formData);
        await this.getNutritionJournals();
        this.calculateChartData();
        this.$refs["form-modal"].hide();
        this.showAlertSuccess();
      }
    },
    addFoodItem() {
      const newForm = { ...this.form };
      newForm.items.push({
        _id: randomId(),
        qty: this.form.foodQty,
        foodItem: this.form.foodItem.data
      });
      newForm.foodQty = 1;
      newForm.foodItem = null;
      this.form = newForm;
    },
    addSupplement() {
      const newForm = { ...this.form };
      newForm.items.push({
        _id: randomId(),
        qty: this.form.supplementQty,
        foodItem: this.form.supplement.data
      });
      newForm.supplementQty = 1;
      newForm.supplement = null;
      this.form = newForm;
    },
    deleteFormItem(deleteId) {
      const newForm = { ...this.form };
      const index = newForm.items.findIndex(u => u._id == deleteId);
      newForm.items.splice(index, 1);
      this.form = newForm;
    },
    deleteJournal() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await nutritionJournalMealServer.delete(this.form.mealRecordId);
          await this.getNutritionJournals();
          this.calculateChartData();
          this.$refs["form-modal"].hide();
          this.showAlertSuccess();
        })
        .catch(function() {});
    },
    exportExcel() {
      this.$refs.grid.exportExcel();
    }
  },
  computed: {
    ...mapState("client", {
      nutritionalItems: state =>
        state.nutritionalJournalItems
          .map(nutritionalJournalItem => ({
            value: nutritionalJournalItem.id,
            label: nutritionalJournalItem.name,
            data: nutritionalJournalItem
          }))
          .sort((a, b) => {
            return a.label.localeCompare(b.label);
          }),
      nutritionMeals: state =>
        state.nutritionMeals.map(nutritionMeal => ({
          value: nutritionMeal.id,
          label: nutritionMeal.name
        }))
    }),
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    items() {
      let items = [];
      if (this.eoc) {
        const dates = enumerateDaysBetweenDates(
          this.eoc.startDate,
          this.eoc.endDate
            ? this.eoc.endDate
            : this.getCurrentAdjustedDateTime()
        );
        dates.reverse();
        for (let index = 0; index < dates.length; index++) {
          const date = dates[index];
          let meals = {};
          const itemDate = this.list.find(
            item => item.date == moment(date).format("YYYY-MM-DD")
          );
          if (itemDate) {
            for (let index2 = 0; index2 < itemDate.meals.length; index2++) {
              const meal = itemDate.meals[index2];
              meals[meal.nutritionMeal.id] = meal;
            }
          }
          items.push({
            date,
            goal: itemDate ? itemDate.goal : 0,
            rmng: itemDate ? itemDate.rmng : 0,
            met: itemDate ? itemDate.met : 0,
            meals: meals
          });
        }
      }

      return items;
    },
    columns() {
      let columns = [
        {
          text: "Date",
          field: "date",
          type: "template",
          width: 140,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return formatDateOnly(record.date);
          }
        },
        {
          text: "Goal",
          field: "goal",
          type: "template",
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return `<input type="number" class="form-control edit-goal-item mr-2" value="${
              record.goal ? record.goal : 0
            }" data-date="${moment(record.date).format(
              "YYYY-MM-DD"
            )}"/ min="0"> cal`;
          },
          width: 150
        },
        {
          text: "Rmng",
          field: "rmng",
          type: "template",
          width: 80,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return record.rmng + " cal";
          }
        },
        {
          text: "Met",
          field: "met",
          type: "template",
          width: 80,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return record.met + " cal";
          }
        }
      ];
      const mealColumns = [];

      for (let index = 0; index < this.nutritionMeals.length; index++) {
        const nutritionMeal = this.nutritionMeals[index];
        mealColumns.push({
          text: nutritionMeal.label,
          field: nutritionMeal.value,
          type: "template",
          width: 190,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return `<div class="d-flex w-100 flex-row justify-content-between align-items-center nutrition-meal-item"><div>${
              record.meals[nutritionMeal.value]
                ? `${
                    record.meals[nutritionMeal.value].percentCosumed
                  }% of meal, 
                ${record.meals[nutritionMeal.value].caloriesConsume} cal`
                : ""
            }</div><img class="b-action-item edit-nutrition-meal-item ml-1" data-meal-id="${
              nutritionMeal.value
            }" data-meal-record-id="${
              record.meals[nutritionMeal.value]
                ? record.meals[nutritionMeal.value].id
                : ""
            }" data-date="${moment(record.date).format(
              "YYYY-MM-DD"
            )}" data-goal="${record.goal}" src="${
              this.isStandalone()
                ? `/icons/edit.svg`
                : `/desktop/icons/edit.svg`
            }"></div>`;
          }
        });
      }

      columns.push({
        text: "% of meals",
        children: mealColumns
      });

      columns.push({
        text: "",
        field: "",
        type: "template",
        flex: 1,
        minWidth: 0,
        editor: false,
        sortable: false,
        template: () => "",
        align: "center"
      });
      return columns;
    },
    formColumns() {
      let columns = [
        {
          text: "Qty",
          field: "qty",
          type: "template",
          width: 80,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return record.qty;
          }
        },
        {
          text: "Category",
          field: "category",
          type: "template",
          width: 180,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return record.foodItem.category
              ? record.foodItem.category.name
              : "";
          }
        },
        {
          text: "Food Item",
          field: "foodItem",
          type: "template",
          width: 180,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return record.foodItem.name;
          }
        },
        {
          text: "Calories per portion",
          field: "caloriesPortion",
          type: "template",
          width: 180,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return record.foodItem.calories;
          }
        },
        {
          text: "Total Calories",
          field: "caloriesToal",
          type: "template",
          width: 180,
          editor: false,
          sortable: false,
          template: ({ record }) => {
            return record.qty * record.foodItem.calories;
          }
        },
        {
          text: "Delete",
          type: "action",
          field: "action",
          cellCls: "pointer-cell",
          align: "right",
          width: 80,
          actions: [
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item mr-2" src=	"${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.deleteFormItem(record.data._id);
              }
            }
          ]
        }
      ];
      return columns;
    },
    foodOptions() {
      return this.nutritionalItems.filter(
        u => u.data.category.name != "Supplements"
      );
    },
    selectedFoodItems() {
      return this.form.items.filter(
        u => u.foodItem.category.name != "Supplements"
      );
    },
    foodItemsTotalCalories() {
      return this.selectedFoodItems.reduce((acc, u) => {
        return (acc += u.qty * u.foodItem.calories);
      }, 0);
    },
    supplementOptions() {
      return this.nutritionalItems.filter(
        u => u.data.category.name == "Supplements"
      );
    },
    selectedSupplements() {
      return this.form.items.filter(
        u => u.foodItem.category.name == "Supplements"
      );
    },
    supplementsTotalCalories() {
      return this.selectedSupplements.reduce((acc, u) => {
        return (acc += u.qty * u.foodItem.calories);
      }, 0);
    },
    formItemsTotal() {
      let total = 0;
      for (let index = 0; index < this.form.items.length; index++) {
        const item = this.form.items[index];
        total += item.qty * item.foodItem.calories;
      }
      return total;
    },
    percentTotalItemsValue() {
      return Math.floor(
        this.form.mealPercent
          ? (this.formItemsTotal * this.form.mealPercent) / 100
          : 0
      );
    },
    percentFromGoal() {
      return Math.floor(
        this.form.goal > 0
          ? (this.percentTotalItemsValue * 100) / this.form.goal
          : 0
      );
    },
    excelExporterFeature() {
      let columns = [
        {
          text: "Date",
          field: "date",
          width: 400,
          renderer(data) {
            return formatDateOnly(data.record.data.date);
          }
        },
        {
          text: "Goal",
          field: "goal",
          width: 400,
          renderer(data) {
            return data.record.goal ? data.record.goal : 0;
          }
        },
        {
          text: "Rmng",
          field: "rmng",
          width: 400,
          renderer(data) {
            return data.record.rmng + " cal";
          }
        },
        {
          text: "Met",
          field: "met",
          width: 400,
          renderer(data) {
            return data.record.met + " cal";
          }
        }
      ];

      for (let index = 0; index < this.nutritionMeals.length; index++) {
        const nutritionMeal = this.nutritionMeals[index];
        columns.push({
          text: nutritionMeal.label,
          field: nutritionMeal.value,
          width: 400,
          renderer(data) {
            return data.record.meals[nutritionMeal.value]
              ? `${
                  data.record.meals[nutritionMeal.value].caloriesConsume
                } cal, ${
                  data.record.meals[nutritionMeal.value].percentCosumed
                }% of meal`
              : "";
          }
        });
      }
      return {
        zipcelx,
        filename: `${this.eoc.mrn}_${this.client.firstName}_${this.client.middleName}_${this.client.lastName}_NutritionalJournal`,
        exporterConfig: {
          columns
        }
      };
    },
    exportFilter() {
      return {
        patientIds: [this.eocId],
        dateFrom: null,
        dateTo: null,
        locationIds: [this.selectedLocation]
      };
    }
  },
  watch: {
    showing: async function(newValue) {
      if (newValue) {
        await this.getNutritionJournals();
        await this.calculateChartData();
      }
    }
  }
};
</script>

<style scoped>
.add-item {
  margin-top: 14px;
  height: 37px;
}
.no-start-date {
  height: calc(100vh - 361px);
}
</style>

<style>
.nutrition-meal-item {
  height: 50px;
}
.nutritional-journal .b-grid-header {
  border: 1px solid #f5f8fc !important;
}
.nutrition-journal-modal-body .b-grid-container .b-container {
  max-height: calc(100vh - 319px) !important;
}
.modal-chart-container {
  height: 60vh;
}
</style>
